export const PRICE_KEYS = [
	'accessibility.prices.currentPrice.variable',
	'accessibility.prices.firstStrikethroughPrice.variable',
	'accessibility.prices.secondStrikethroughPrice.variable',
	'accessibility.prices.thirdStrikethroughPrice.variable',
	'pdp.priceDescription.tooltip',
	'pdp.priceDescription.outlet.tooltip',
	'pdp.previousPrices.outlet.tooltip',
]
